import animateScrollTo from 'animated-scroll-to';
import { listPaymentMethods } from '@rechargeapps/storefront-client';
import { getCustomer } from '@rechargeapps/storefront-client';
import { updateCustomer } from '@rechargeapps/storefront-client';

export default class CustomerPortal extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onResize = this.onResize.bind(this);
    this.onClickMenuBtn = this.onClickMenuBtn.bind(this);
    this.onClickCloseBtn = this.onClickCloseBtn.bind(this);
    this.onClickMenuItem = this.onClickMenuItem.bind(this);
    this.onClickStoreCreditCheckbox = this.onClickStoreCreditCheckbox.bind(this);
    this.onClickUpdatePaymentBtn = this.onClickUpdatePaymentBtn.bind(this);
    this.onClickEditAddressBtn = this.onClickEditAddressBtn.bind(this);
    this.onClickCancelAddressBtn = this.onClickCancelAddressBtn.bind(this);
    this.onClickSubmitAddressBtn = this.onClickSubmitAddressBtn.bind(this);
    this.onClickAddAddressBtn = this.onClickAddAddressBtn.bind(this);
    this.onClickRemoveAddressBtn = this.onClickRemoveAddressBtn.bind(this);
    this.onClickCloseNotification = this.onClickCloseNotification.bind(this);
    this.onSubmitConvertForm = this.onSubmitConvertForm.bind(this);

    this.onClickCopyCodeLink = this.onClickCopyCodeLink.bind(this);

    this.onClickToggleOrderBtn = this.onClickToggleOrderBtn.bind(this);

    this.onClickReferralHistoryBtn = this.onClickReferralHistoryBtn.bind(this);

    this.initRivo = this.initRivo.bind(this);

    // privates
    this._node = this;
    this._menu = this._node.querySelector('.customer-portal-menu');
    this._menu_btn = this._node.querySelector('.menu-btn');
    this._close_btn = this._node.querySelector('.close-menu-btn');
    this._menu_item = this._node.querySelectorAll('.menu-item');
    this._portal_page = this._node.querySelectorAll('.customer-portal-page');
    this._payment_method_btn = this._node.querySelector('.update-payment-btn');
    this._edit_address_btn = this._node.querySelectorAll('.edit-address-btn');
    this._cancel_address_btn = this._node.querySelectorAll('.cancel-address-btn');
    this._submit_address_btn = this._node.querySelectorAll('.submit-address-btn');
    this._add_address_btn = this._node.querySelectorAll('.add-address-btn');
    this._remove_address_btn = this._node.querySelectorAll('.remove-address-btn');
    this._close_notification = this._node.querySelectorAll('.close-notification');
    this._new_address_card = this._node.querySelector('.new-address-card');

    this._customer_id = this._node.hasAttribute('data-cid') ? parseInt(this._node.getAttribute('data-cid'), 10) : false;
    this._customer_email = this._node.hasAttribute('data-email') ? this._node.getAttribute('data-email') : false;

    this._store_credit_amt = this._node.querySelectorAll('.store-credit-amt');
    this._store_credit_checkbox = this._node.querySelectorAll('.store-credit-checkbox');
    this._current_store_credit_module = null;
    this._convert_form = this._node.querySelector('.convert-form');
    this._convert_input = this._convert_form.querySelector('input');
    this._convert_btn = this._convert_form.querySelector('.convert-btn');
    this._convert_notification = this._node.querySelector('.convert-notification');
    this._convert_notification_msg = this._convert_notification.querySelector('p');
    this._convert_submitting = false;

    this._toggle_order_btn = this._node.querySelectorAll('.toggle-order-btn');

    this._referral_card = this._node.querySelectorAll('.referral-card');
    if (this._referral_card.length > 0) {
      this._referral_history_btn = this._node.querySelector('.referral-history-btn');
      this._rivo_link = this._node.querySelectorAll('.rivo-referral-link');
      this._referrals_list = this._node.querySelector('.referrals-list');
      this._rivo_row = this._node.querySelectorAll('.rivo-row');
    }

    this._recharge_session = null;
    this._recharge_address_id = false;
    this._recharge_payment_method_id = false;
    this._credit_card_info = this._node.querySelector('.credit-card-info');

    this._modal = document.getElementById('modal-wrapper');

    // events
    window.addEventListener('resize', this.onResize);
    this._menu_btn.addEventListener('click', this.onClickMenuBtn);
    this._close_btn.addEventListener('click', this.onClickCloseBtn);

    this._menu_item.forEach((el) => {
      el.addEventListener('click', this.onClickMenuItem);
    });

    this._store_credit_checkbox.forEach((el) => {
      el.addEventListener('click', this.onClickStoreCreditCheckbox);
    });

    if (this._payment_method_btn) {
      this._payment_method_btn.addEventListener('click', this.onClickUpdatePaymentBtn);
    }

    this._edit_address_btn.forEach((el) => {
      el.addEventListener('click', this.onClickEditAddressBtn);
    });

    this._cancel_address_btn.forEach((el) => {
      el.addEventListener('click', this.onClickCancelAddressBtn);
    });

    this._submit_address_btn.forEach((el) => {
      el.addEventListener('click', this.onClickSubmitAddressBtn);
    });

    this._add_address_btn.forEach((el) => {
      el.addEventListener('click', this.onClickAddAddressBtn);
    });

    this._remove_address_btn.forEach((el) => {
      el.addEventListener('click', this.onClickRemoveAddressBtn);
    });

    this._close_notification.forEach((el) => {
      el.addEventListener('click', this.onClickCloseNotification);
    });

    if (this._convert_form) {
      this._convert_form.addEventListener('submit', this.onSubmitConvertForm);
    }

    if (this._toggle_order_btn.length > 0) {
      this._toggle_order_btn.forEach((el) => {
        el.addEventListener('click', this.onClickToggleOrderBtn);
      });
    }

    if (this._referral_card.length > 0) {
      this._referral_history_btn.addEventListener('click', this.onClickReferralHistoryBtn);
      document.addEventListener('rivo-js-loaded', this.initRivo);
    }


    // init
    this.onResize();
    this.checkSearchParams();

    // Fill out dashboard...
    if (this._customer_id && this._customer_email) {
      this.updateStoreCredit();
      this._node.removeAttribute('data-cid');
      this._node.removeAttribute('data-email');
    }

    // Fill out Recharge...
    this.getPaymentMethods();
  }

  async submitStoreCredit(apply_credit) {
    try {
      this._store_credit_checkbox.forEach((el, i) => {
        el.classList.add('--loading');
      });

      const customer_response = await recharge.credit.setApplyCreditsToNextCharge(this._recharge_session, { recurring: apply_credit });

      if (customer_response) {
        this.updateStoreCreditCheckboxes(apply_credit);
        this.showStoreCreditNotification("Your settings have been saved.", false);
      }
    }
    catch (error) {
      this.showStoreCreditNotification("An unknown error occurred. Please try again later.", true);
    }
  }

  showStoreCreditNotification(message, error) {
    let notification = this._current_store_credit_module.querySelector('.notification-bar'),
        notification_msg = notification.querySelector('p');

    notification_msg.innerText = message;
    notification.classList.remove('--show', 'error');
    notification.classList.add('--show');

    if (error) {
      notification.classList.add('error');

      this._store_credit_checkbox.forEach((el, i) => {
        el.classList.remove('--loading');
      });
    }
  }

  onResize() {
    if (window.innerWidth >= 768 && this._menu.classList.contains('--show')) {
      this.closeDrawer();
    }
  }

  updateStoreCredit() {
    this._store_credit_amt.forEach((el) => {
      el.classList.add('--loading');
    });

    fetch(new Request("https://aerflo.co/apps/rise-ai/customer"), {
      method: 'GET',
      headers: {
        'X-RISE-METHOD': 'GET'
      }
    })
    .then((response) => {
      if (!response.ok) {
        let store_credit_labels = this._node.querySelectorAll('.store-credit-label');
        store_credit_labels.forEach((item, i) => {
          item.classList.remove('fs-24');
          item.classList.add('fs-large', 'orange', 'bold');
          item.innerHTML = "Error fetching your store credit. Please try again later."
        });

        throw new Error(`HTTP error! Status: ${response.status}`);
      } else {
        return response.json();
      }
    })
    .then((customer) => {
      let balance = customer?.LoyaltyCard?.GiftCard?.balance;

      if (balance) {
        this._store_credit_amt.forEach((el) => {
          el.innerText = `$${balance}`;
          el.classList.remove('--loading');
        });
      } else {
        this._store_credit_amt.forEach((el) => {
          el.classList.remove('--loading');
        });
      }
    });
  }

  async login() {
    this._recharge_session = await recharge.auth.loginShopifyAppProxy();
  }

  async getPaymentMethods() {
    await this.login();

    if (!this._recharge_session.customerId) {
      this._payment_method_btn.style.display = "none";
      this._credit_card_info.classList.add('gray');
      this._credit_card_info.classList.remove('--loading');
      this._credit_card_info.innerHTML = "You don't have a payment method with Recharge set up yet.";

      // Remove these because they don't have recharge session to apply to...
      this._store_credit_checkbox.forEach((el) => {
        el.remove();
      });
    } else {
      const customer_data = await recharge.customer.getCustomer(this._recharge_session, { include: ['addresses'] });
      const payment_methods_response = await recharge.paymentMethod.listPaymentMethods(this._recharge_session, { limit: 25 });
      const payment_methods = payment_methods_response.payment_methods;
      const addresses = customer_data?.include?.addresses;

      if (customer_data) {
        this.updateStoreCreditCheckboxes(customer_data.apply_credit_to_next_recurring_charge);
      }

      if (payment_methods_response && payment_methods && payment_methods.length > 0) {
        let payment_method = payment_methods.filter(item => {
          return item.default;
        });


        let payment_details = payment_method[0].payment_details;
        this._recharge_payment_method_id = payment_method[0].id;

        this._credit_card_info.classList.add(payment_details.brand);
        this._credit_card_info.classList.remove('--loading');
        this._credit_card_info.innerHTML = `<span></span>xxxx xxxx xxxx ${payment_details.last4}`;
        this._payment_method_btn.style.display = "block";

        if (addresses && addresses.length > 0) {
          let billing_address = addresses.filter(item => {
            return item.payment_method_id === this._recharge_payment_method_id;
          });
          this._recharge_address_id = billing_address[0].id;
        }
      }
    }
  }

  onClickCopyCodeLink(e) {
    let el = e.currentTarget,
        code = el.hasAttribute('data-code') ? el.getAttribute('data-code') : false;

    el.classList.remove('--copied');

    if (code && navigator) {
      navigator.clipboard.writeText(code);
      el.classList.add('--copied');

      setTimeout(() => {
        el.classList.remove('--copied');
      }, 3000);
    }
  }

  onSubmitConvertForm(e) {
    e.preventDefault();

    if (this._convert_submitting) {
      return false;
    }

    let val = this._convert_input.value.trim();

    if (val !== '') {
      this._convert_submitting = true;
      this._convert_btn.classList.add('--sending');
      this._convert_notification.classList.remove('--show', 'error');

      fetch(new Request(`https://application.rise-ai.com/v1/gift-cards/customers/${this._customer_id}?shop_url=allspritz.myshopify.com&customer_email=${this._customer_email}`), {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code: val }),
      })
      .then((response) => {
        if (!response.ok) {
          this._convert_submitting = false;
          this._convert_btn.classList.remove('--sending');
          this._convert_notification.classList.add('--show', 'error');
          this._convert_notification_msg.innerText = 'Code not found! Please re-enter your code and try again.';
          throw new Error(`HTTP error! Status: ${response.status}`);
        } else {
          return response.json();
        }
      })
      .then((response) => {
        if (response) {
          this.updateStoreCredit();

          // Clear input field...
          this._convert_input.value = '';

          // Notification
          this._convert_notification.classList.add('--show');
          this._convert_notification_msg.innerText = 'Success! Your gift card has been converted to store credit.';
        }

        this._convert_submitting = false;
        this._convert_btn.classList.remove('--sending');
      });
    }
  }

  onClickMenuBtn() {
    this.openDrawer();
  }

  onClickCloseBtn() {
    this.closeDrawer();
  }

  openDrawer() {
    this._menu.classList.add('--show');
    document.body.style.overflow = 'hidden';
  }

  closeDrawer() {
    this._menu.classList.remove('--show');
    document.body.style.overflow = '';
  }

  onClickMenuItem(e) {
    e.preventDefault();
    let el = e.currentTarget,
        id = el.getAttribute('data-id');

    this.closeDrawer();

    if (el.classList.contains('--current')) {
      return false;
    }

    this._menu_item.forEach((el) => {
      el.classList.remove('--current');
    });

    el.classList.add('--current');

    this._portal_page.forEach((el) => {
      el.classList.remove('--show');
      if (el.getAttribute('id') === id) {
        el.classList.add('--show');
      }
    });

    if (window.pageYOffset > 50) {
      animateScrollTo(0);
    }

    if (history.replaceState) {
      let new_url = window.location.origin + el.getAttribute('href');
      window.history.replaceState(null, '', new_url);
    }
  }

  updateStoreCreditCheckboxes(apply_credit) {
    this._store_credit_checkbox.forEach((el, i) => {
      el.classList.remove('--checked', '--loading');

      if (apply_credit) {
        el.classList.add('--checked');
      }
    });
  }

  onClickStoreCreditCheckbox(e) {
    let el = e.currentTarget;
    this._current_store_credit_module = el.closest('.module-card');

    if (el.classList.contains('--checked')) {
      this._modal.dataset.open_store_credit_unapply = true;
    } else {
      this._modal.dataset.open_store_credit_apply = true;
    }
  }

  onClickToggleOrderBtn(e) {
    let el = e.currentTarget,
        order_block = el.closest('.order-block');

    if (order_block.classList.contains('--expanded')) {
      order_block.classList.remove('--expanded');
    } else {
      order_block.classList.add('--expanded');
    }
  }

  initRivo() {
    RivoJS.getCustomerReferrals()
    .then((resp) => {
      this._rivo_link.forEach((el) => {
        el.querySelector('p.link-icon').innerHTML = resp.url;
        el.setAttribute('data-code', resp.url);
        el.addEventListener('click', this.onClickCopyCodeLink);
      });

      let completed = resp.completed,
          referrals = resp.referrals,
          total_referrals = resp.referrals.length,
          referrals_html = '';

      if (referrals && total_referrals > 0) {
        this._node.querySelector('.completed-stat').innerHTML = completed;
        this._node.querySelector('.unclaimed-stat').innerHTML = resp.referrals.length - completed;

        referrals.forEach((referral) => {
          let completed = referral.status.toLowerCase() === 'completed' ? true : false;

          referrals_html += `<div class="referral-item rad">
            <div class="col long-wrap">${referral.email ? referral.email : '—'}</div>
            <div class="col">
              <div class="status-label ${completed ? '--completed' : ''}">${completed ? 'Completed' : 'Unclaimed'}</div>
            </div>
          </div>`;
        });

        this._referrals_list.innerHTML = referrals_html;
      } else {
        this._node.querySelector('.referrals-legend').remove();
      }

      this._rivo_row.forEach((el) => {
        el.querySelector('.--loading').remove();
        el.querySelector('.sub-col').style.display = "block";
      });

      this._node.querySelector('.referral-stats-list').style.display = "block";
    });
  }

  onClickReferralHistoryBtn() {
    this._node.querySelector('.menu-item[href="/account?page=referral"]').click();
  }

  onClickUpdatePaymentBtn(e) {
    let module_card = e.currentTarget.closest('.module-card');

    if (this._recharge_session && this._recharge_payment_method_id && this._recharge_address_id) {
      this.sendCustomerNotification(module_card);
    }
  }

  async sendCustomerNotification(module_card) {
    let notification = module_card.querySelector('.notification-bar'),
        notification_msg = notification.querySelector('p'),
        email = notification.getAttribute('data-email');

    notification.classList.remove('--show', 'error');

    try {
      const update_payment = await recharge.customer.sendCustomerNotification(this._recharge_session, 'SHOPIFY_UPDATE_PAYMENT_INFO', {
        address_id: this._recharge_address_id,
        payment_method_id: this._recharge_payment_method_id
      });

      notification_msg.innerText = `An email was sent to ${email}. Please click on the link in the email to update payment method.`;
      notification.classList.add('--show');
    } catch (error) {
      notification_msg.innerText = `An error occurred. Please try again later.`;
      notification.classList.add('error', '--show');
    }
  }

  onClickEditAddressBtn(e) {
    let module_card = e.currentTarget.closest('.module-card'),
        address_form = module_card.querySelector('.address-form-block');

    address_form.style.display = "block";
  }

  onClickCancelAddressBtn(e) {
    let module_card = e.currentTarget.closest('.module-card'),
        address_form = module_card.querySelector('.address-form-block');

    address_form.style.display = "none";

    if (module_card.classList.contains('new-address-card')) {
      module_card.style.display = "none";
    }
  }

  onClickSubmitAddressBtn(e) {
    let form = e.currentTarget.closest('form'),
        is_valid = form.reportValidity();

    if (is_valid) {
      e.currentTarget.classList.add('--sending');
    }
  }

  onClickAddAddressBtn(e) {
    this._new_address_card.style.display = "block";
    this._new_address_card.querySelector('.address-form-block').style.display = "block";
  }

  onClickRemoveAddressBtn(e) {
    // if (!confirm('Are you sure you wish to delete this address?')) return

    let target = e.currentTarget,
        id = target.getAttribute('data-id'),
        form_html = `
          <form style="display: none" class="address-delete-form" method="post" action="/account/addresses/${id}" accept-charset="UTF-8">
            <input type="hidden" name="_method" value="delete">
            <input type="hidden" name="return_to" value="/account?page=capsule-exchange">
            <button type="submit">Delete Address</button>
          </form>
        `;

    target.appendChild(form_html);
  }

  onClickCloseNotification(e) {
    let notification = e.currentTarget.closest('.notification-bar');
    notification.classList.remove('--show');
  }

  checkSearchParams() {
    let params = new URLSearchParams(document.location.search),
        page = params.get("page");

    if (page) {
      let current_menu_item = this._node.querySelector(`.menu-item[data-id="${page}"]`);
      if (current_menu_item) {
        current_menu_item.click();
      }
    } else {
      this._menu_item[0].click();
    }
  }

  /**
   * Handle unmount.
   */
   disconnectedCallback() {
     window.removeEventListener('resize', this.onResize);
     this._menu_btn.removeEventListener('click', this.onClickMenuBtn);
     this._close_btn.removeEventListener('click', this.onClickCloseBtn);

     this._menu_item.forEach((el) => {
       el.removeEventListener('click', this.onClickMenuItem);
     });

     this._store_credit_checkbox.forEach((el) => {
       el.removeEventListener('click', this.onClickStoreCreditCheckbox);
     });

     if (this._payment_method_btn) {
       this._payment_method_btn.removeEventListener('click', this.onClickUpdatePaymentBtn);
     }

     this._edit_address_btn.forEach((el) => {
       el.removeEventListener('click', this.onClickEditAddressBtn);
     });

     this._cancel_address_btn.forEach((el) => {
       el.removeEventListener('click', this.onClickCancelAddressBtn);
     });

     this._submit_address_btn.forEach((el) => {
       el.removeEventListener('click', this.onClickSubmitAddressBtn);
     });

     this._add_address_btn.forEach((el) => {
       el.removeEventListener('click', this.onClickAddAddressBtn);
     });

     this._remove_address_btn.forEach((el) => {
       el.removeEventListener('click', this.onClickRemoveAddressBtn);
     });

     this._close_notification.forEach((el) => {
       el.removeEventListener('click', this.onClickCloseNotification);
     });

     if (this._convert_form) {
       this._convert_form.removeEventListener('submit', this.onSubmitConvertForm);
     }

     if (this._toggle_order_btn.length > 0) {
       this._toggle_order_btn.forEach((el) => {
         el.addEventListener('click', this.onClickToggleOrderBtn);
       });
     }

     if (this._referral_card.length > 0) {
       this._rivo_link.forEach((el) => {
         el.removeEventListener('click', this.onClickCopyCodeLink);
       });

       this._referral_history_btn.removeEventListener('click', this.onClickReferralHistoryBtn);
       document.removeEventListener('rivo-js-loaded', this.initRivo);
     }
  }
}
